var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.72751 13.05C8.72751 14.7877 10.1986 16.2 12.0088 16.2C13.8189 16.2 15.29 14.7877 15.29 13.05C15.29 11.3122 13.8189 9.9 12.0088 9.9C10.1986 9.9 8.72751 11.3122 8.72751 13.05Z",
    fill: "#F2962E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2588 19.9642L21.2588 7.8L14.6963 1.5H4.00867L2.75867 22.5H19.7874L15.0166 17.4233C14.158 17.9745 13.1244 18.3 12.0088 18.3C8.99001 18.3 6.54001 15.948 6.54001 13.05C6.54001 10.152 8.99001 7.8 12.0088 7.8C15.0275 7.8 17.4775 10.152 17.4775 13.05C17.4775 14.121 17.1385 15.1132 16.5697 15.9427L20.2588 19.9642Z",
    fill: "#F2962E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.457f10eb6c6b88618fe2704bd00e723d.svg";
export { ForwardRef as ReactComponent };